import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/branding/centrallize-light-mark-clean.png'
import _imports_1 from '../../assets/images/home/system77.png'
import _imports_2 from '../../assets/images/home/mobile2.png'
import _imports_3 from '../../assets/images/home/mobile3.png'
import _imports_4 from '../../assets/branding/centrallize-mark-ui.jpg'


const _withScopeId = n => (_pushScopeId("data-v-99beb47a"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_2
const _hoisted_2 = { class: "sales-page" }
const _hoisted_3 = { class: "sales-header" }
const _hoisted_4 = { class: "sales-container header-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "brand",
  "aria-label": "Centrallize"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Símbolo da Centrallize"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Centrallize")
], -1))
const _hoisted_6 = {
  class: "nav-links",
  "aria-label": "Navegação principal"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/login",
  class: "login-link"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-user-circle" }),
  /*#__PURE__*/_createTextVNode(" Entrar ")
], -1))
const _hoisted_8 = { class: "hero-section" }
const _hoisted_9 = { class: "sales-container hero-grid" }
const _hoisted_10 = { class: "hero-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Automatize o atendimento do seu negócio pelo WhatsApp", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hero-copy" }, " Organize agenda, clientes, equipe, produtos, estoque e financeiro em uma plataforma que responde, verifica horários e ajuda a transformar mensagens em agendamentos. ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "microcopy" }, "Teste a plataforma e configure seus primeiros serviços em poucos minutos.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "trust-row",
  "aria-label": "Destaques do produto"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "WhatsApp 24h"),
    /*#__PURE__*/_createElementVNode("span", null, "respostas mesmo fora do expediente")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Agenda clara"),
    /*#__PURE__*/_createElementVNode("span", null, "horários por profissional")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Gestão completa"),
    /*#__PURE__*/_createElementVNode("span", null, "clientes, vendas e financeiro")
  ])
], -1))
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"hero-visual\" aria-label=\"Prévia do sistema Centrallize\" data-v-99beb47a><div class=\"dashboard-shell\" data-v-99beb47a><div class=\"dashboard-toolbar\" data-v-99beb47a><span data-v-99beb47a></span><span data-v-99beb47a></span><span data-v-99beb47a></span></div><img src=\"" + _imports_1 + "\" alt=\"Tela do painel Centrallize\" data-v-99beb47a></div><div class=\"metric-card metric-card--sales\" data-v-99beb47a><span data-v-99beb47a>Acompanhe os valores do mês, exemplo:</span><strong data-v-99beb47a>R$ 7.184,20</strong><small data-v-99beb47a>Do começo ao final do mês</small></div><div class=\"floating-card floating-card--top\" data-v-99beb47a><i class=\"ph ph-whatsapp-logo\" data-v-99beb47a></i><div data-v-99beb47a><strong data-v-99beb47a>WhatsApp automatizado</strong><span data-v-99beb47a>Agendamento 24 horas por dia</span></div></div><div class=\"floating-card floating-card--bottom\" data-v-99beb47a><i class=\"ph ph-chart-line-up\" data-v-99beb47a></i><div data-v-99beb47a><strong data-v-99beb47a>Mais horários ocupados</strong><span data-v-99beb47a>Atendimento automático reduz perdas</span></div></div></div>", 1)
const _hoisted_17 = {
  id: "como-funciona",
  class: "workflow-section"
}
const _hoisted_18 = { class: "sales-container space-top-mobile" }
const _hoisted_19 = { class: "workflow-panel" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-heading section-heading--left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-label" }, "Como funciona"),
  /*#__PURE__*/_createElementVNode("h2", null, "Da primeira mensagem ao controle financeiro, tudo conectado.")
], -1))
const _hoisted_21 = { class: "workflow-steps" }
const _hoisted_22 = { class: "feature-showcase" }
const _hoisted_23 = { class: "sales-container showcase-grid space-top-mobile" }
const _hoisted_24 = { class: "showcase-copy" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-label" }, "Gestão completa", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Você para de adivinhar e passa a enxergar a rotina do negócio.", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "showcase-image" }, [
  /*#__PURE__*/_createElementVNode("picture", null, [
    /*#__PURE__*/_createElementVNode("source", {
      media: "(max-width: 767px)",
      srcset: _hoisted_1
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "Tela de gestão do Centrallize"
    })
  ])
], -1))
const _hoisted_29 = {
  id: "planos",
  class: "pricing-section"
}
const _hoisted_30 = { class: "sales-container space-top-mobile" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-heading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-label" }, "Planos"),
  /*#__PURE__*/_createElementVNode("h2", null, "Comece com uma ferramenta que ajuda a recuperar tempo e oportunidades."),
  /*#__PURE__*/_createElementVNode("p", null, "Escolha um plano, cadastre seus serviços e deixe o WhatsApp trabalhar junto com sua equipe.")
], -1))
const _hoisted_32 = {
  key: 0,
  class: "pricing-feedback"
}
const _hoisted_33 = {
  key: 1,
  class: "pricing-feedback pricing-feedback--error"
}
const _hoisted_34 = {
  key: 2,
  class: "pricing-grid"
}
const _hoisted_35 = {
  key: 0,
  class: "plan-tag plan-tag--unavailable"
}
const _hoisted_36 = {
  key: 1,
  class: "plan-tag"
}
const _hoisted_37 = { class: "price" }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "pricing-card__cta" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" }, null, -1))
const _hoisted_41 = {
  key: 1,
  class: "pricing-button pricing-button--unavailable"
}
const _hoisted_42 = { key: 2 }
const _hoisted_43 = { key: 3 }
const _hoisted_44 = {
  key: 3,
  class: "pricing-feedback"
}
const _hoisted_45 = { class: "final-cta" }
const _hoisted_46 = { class: "sales-container final-cta-inner space-top-mobile" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-label" }, "Próximo passo"),
  /*#__PURE__*/_createElementVNode("h2", null, "Seu atendimento pode continuar funcionando enquanto você cuida dos clientes."),
  /*#__PURE__*/_createElementVNode("p", null, "Coloque agenda, WhatsApp, clientes e financeiro em uma operação simples de acompanhar.")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" }, null, -1))
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<footer class=\"sales-footer\" data-v-99beb47a><div class=\"sales-container footer-grid\" data-v-99beb47a><div data-v-99beb47a><a href=\"#\" class=\"brand brand--footer text-color-footer\" data-v-99beb47a><img src=\"" + _imports_4 + "\" alt=\"Símbolo da Centrallize\" data-v-99beb47a><span data-v-99beb47a>Centrallize</span></a><p class=\"text-color-footer\" data-v-99beb47a>Gestão e automação de atendimento para negócios de beleza, estética e serviços.</p></div><div class=\"footer-links\" data-v-99beb47a><a class=\"text-color-footer\" href=\"/login\" data-v-99beb47a>Entrar</a><a class=\"text-color-footer\" href=\"/register\" data-v-99beb47a>Registrar-se</a><a class=\"text-color-footer\" href=\"/terms\" target=\"_blank\" data-v-99beb47a>Termos e Condições</a><a class=\"text-color-footer\" href=\"/privacy-policy\" target=\"_blank\" data-v-99beb47a>Política de privacidade</a></div><div class=\"footer-contact\" data-v-99beb47a><span class=\"text-color-footer\" data-v-99beb47a>Contato:</span><a class=\"text-color-footer\" href=\"mailto:contato@sanvault.com.br\" data-v-99beb47a>contato@sanvault.com.br</a><a class=\"text-color-footer\" href=\"https://www.linkedin.com/company/sanvault-tecnologia/\" target=\"_blank\" data-v-99beb47a>LinkedIn</a></div></div><div class=\"sales-container copyright text-color-footer\" data-v-99beb47a> (c) 2026 Centrallize. Todos os direitos reservados. </div></footer>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_2, [
    _createElementVNode("header", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("nav", _hoisted_6, [
          _createElementVNode("a", {
            href: "#como-funciona",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.scrollToSection('como-funciona')), ["prevent"]))
          }, "Como funciona"),
          _createElementVNode("a", {
            href: "#planos",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.scrollToSection('planos')), ["prevent"]))
          }, "Planos")
        ]),
        _hoisted_7
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("form", {
            class: "hero-form",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.leadEmail) = $event)),
              type: "email",
              placeholder: "Insira seu e-mail",
              "aria-label": "E-mail"
            }, null, 512), [
              [
                _vModelText,
                _ctx.leadEmail,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode(_component_router_link, {
              to: _ctx.registerEmailRoute(),
              class: "primary-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Começar agora "),
                _hoisted_13
              ]),
              _: 1
            }, 8, ["to"])
          ], 32),
          _hoisted_14,
          _hoisted_15
        ]),
        _hoisted_16
      ])
    ]),
    _createElementVNode("section", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workflowSteps, (step, index) => {
              return (_openBlock(), _createElementBlock("article", {
                key: step.title
              }, [
                _createElementVNode("span", null, _toDisplayString(index + 1), 1),
                _createElementVNode("h3", null, _toDisplayString(step.title), 1),
                _createElementVNode("p", null, _toDisplayString(step.description), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _hoisted_26,
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coreFeatures, (feature) => {
              return (_openBlock(), _createElementBlock("li", { key: feature }, _toDisplayString(feature), 1))
            }), 128))
          ]),
          _createElementVNode("a", {
            href: "#planos",
            class: "primary-button primary-button--dark",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.scrollToSection('planos')), ["prevent"]))
          }, [
            _createTextVNode(" Quero organizar meu negócio "),
            _hoisted_27
          ])
        ]),
        _hoisted_28
      ])
    ]),
    _createElementVNode("section", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        (_ctx.loadingHomePlans)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, " Carregando planos... "))
          : (_ctx.errorHomePlans)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.errorHomePlans), 1))
            : (_ctx.availablePlans.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePlans, (plan) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: plan.id || plan.name,
                      class: _normalizeClass(["pricing-card", { 'pricing-card--unavailable': !_ctx.isPlanAvailable(plan) }])
                    }, [
                      (!_ctx.isPlanAvailable(plan))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.planAvailabilityLabel(plan)), 1))
                        : (_ctx.availablePlans.length == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, "PLANO ÚNICO"))
                          : _createCommentVNode("", true),
                      _createElementVNode("h3", null, _toDisplayString(plan.name || plan.title || 'Plano Centrallize'), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.formatPlanDescription(plan)), 1),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.formatPlanPrice(plan)), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatPlanBillingCycle(plan)), 1)
                      ]),
                      (_ctx.formatPlanFeatures(plan).length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_38, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatPlanFeatures(plan), (feature, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(feature), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_39, [
                        (_ctx.isPlanAvailable(plan))
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: _ctx.registerPlanRoute(plan),
                              class: "pricing-button"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Escolher plano "),
                                _hoisted_40
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.planAvailabilityLabel(plan)), 1)),
                        (_ctx.isPlanAvailable(plan))
                          ? (_openBlock(), _createElementBlock("small", _hoisted_42, "Sem taxa de setup. Cancele quando quiser."))
                          : (_openBlock(), _createElementBlock("small", _hoisted_43, "Este plano ainda não pode ser contratado."))
                      ])
                    ], 2))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_44, " Nenhum plano disponivel no momento. "))
      ])
    ]),
    _createElementVNode("section", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createVNode(_component_router_link, {
          to: "/register",
          class: "primary-button final-cta-button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Começar "),
            _hoisted_48
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_49
  ]))
}